import { MtStudy } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"

export const setStudyBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.STUDY_BASE_ROUTE),
    baseRoute,
})


export const setStudyList = (studyList: types.StudyList) => ({
    type: inferLiteral(types.STUDY_LIST),
    studyList,
})
export const setStudyIds = (studyIds: readonly number[]) => ({
    type: inferLiteral(types.STUDY_IDS),
    studyIds,
})
export const setStudyView = (study: MtStudy) => ({
    type: inferLiteral(types.STUDY_VIEW),
    study,
})
export const setStudyEdit = (study: MtStudy) => ({
    type: inferLiteral(types.STUDY_EDIT),
    study,
})


export const setStudySort = (sortColumn: keyof MtStudy, sortOrder: OrderType) => ({
    type: inferLiteral(types.STUDY_SORT),
    sortColumn,
    sortOrder,
})
export const setStudyFilters = (filters: types.StudyFilters) => ({
    type: inferLiteral(types.STUDY_FILTERS),
    filters,
})


export const setStudyReloadList = (value: boolean) => ({
    type: inferLiteral(types.STUDY_RELOAD_LIST),
    value,
})
export const setStudyReloadView = (value: boolean) => ({
    type: inferLiteral(types.STUDY_RELOAD_VIEW),
    value,
})
export const setStudyReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.STUDY_RELOAD_EDIT),
    value,
})
